function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTyp1Symbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 52.916665 52.916666",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#9e9e9e",
      strokeWidth: 3,
      strokeOpacity: 1
    },
    cx: 26.467819,
    cy: 26.479063,
    r: 25.052963
  }), /*#__PURE__*/React.createElement("text", {
    x: 26.5,
    y: 30,
    textAnchor: "middle",
    style: {
      fontSize: 16,
      fontFamily: "'Segoe UI',sans-serif",
      fill: "none",
      stroke: "#9e9e9e",
      strokeWidth: 1.2,
      strokeOpacity: 1
    }
  }, "SG"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTyp1Symbol);
export default __webpack_public_path__ + "static/media/Typ1Symbol.d3ec8f1ae84e151fce8168f503a7da15.svg";
export { ForwardRef as ReactComponent };